export const statusLabels = { PENDIENTE: 'Pendiente de aprobación', CONFIRMADA: 'Confirmada', RECHAZADA: 'Rechazada', CANCELADA: 'Cancelada', COMPLETADA: 'Completada' };
export const statusColors = { PENDIENTE: 'warning', CONFIRMADA: 'success', RECHAZADA: 'error', CANCELADA: 'default', COMPLETADA: 'info' };
export const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
export function availableSlots(config, fecha, now = new Date()) {
  if (!config || !fecha || !(config.diasLaborales || []).includes(new Date(`${fecha}T12:00`).getDay())) return [];
  const toMinutes = t => { const [h, m] = t.split(':').map(Number); return h * 60 + m; };
  const start = toMinutes(config.horarios?.inicio || '09:00');
  const end = toMinutes(config.horarios?.fin || '18:00');
  const interval = Number(config.horarios?.intervalo || 60);
  if (!Number.isFinite(interval) || interval <= 0) return [];
  const slots = [];
  const occupied = (config.citasOcupadas || []).filter(c => c.fecha === fecha).map(c => c.hora);
  for (let m = start; m + interval <= end; m += interval) {
    const h = `${String(Math.floor(m / 60)).padStart(2, '0')}:${String(m % 60).padStart(2, '0')}`;
    if (new Date(`${fecha}T${h}`) > now && !occupied.includes(h)) slots.push(h);
  }
  return slots;
}
export const businessAppointments = (citas, ownerId) => ownerId ? citas.filter(c => String(c.ownerId?._id || c.ownerId) === String(ownerId)) : [];
